import axios from 'axios';
import { AppConfig } from 'AppConfig';
import LocalStore from 'utils/LocalStore';

/**
 * Fetch all Performance Metrics tile values in a single VDS-backed call.
 *
 * @param {Object} requestBody - PerformanceMetricsRequestDto fields:
 *   tenantCd, dateBasis, currentStart, currentEnd, priorStart, priorEnd,
 *   division (string[]), plan (string[]), personIds (string[])
 * @returns {Promise<Object>} Flat map of alias → numeric value (or null)
 */
export async function getAllPerformanceMetrics(requestBody) {
  const url = `${AppConfig.FO_INITIAL_URL}/tbl/perf-mats-vds`;
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + LocalStore.getAccessToken()
  };
  try {
    const response = await axios.post(url, requestBody, { headers, hideSpinner: true, suppressErrorSnackbar: true });
    const data = response.data;
    const fieldCount = data && typeof data === 'object' ? Object.keys(data).length : 0;
    if (fieldCount === 0) {
      throw new Error('getAllPerformanceMetrics returned empty response — VDS may have failed silently');
    }
    return data;
  } catch (error) {
    const wrapped = new Error(`getAllPerformanceMetrics failed: ${error?.message || 'Unknown error'}`);
    wrapped.cause = error;
    throw wrapped;
  }
}
